export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0022.8b390eec.webp";